import api from '../token';

export const AddProduto = async (payload) => {
  try {
    const response = await api.post('/store',payload);
    return response.data;
  } catch (error) {
   
    return [];
  }
};

